import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, MaskedLines } from "./motion";

const CTABanner = ({
  title = ["Ready to start", "your project?"],
  sub = "Get in touch today for a free, no-obligation quote — we usually respond within one working day.",
  cta = "Get Your Free Quote",
}) => (
  <section className="container-ek py-20 lg:py-28">
    <Reveal>
      <div className="relative overflow-hidden bg-gradient-to-br from-gold2 via-gold to-[#a8873a]">
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage:
              "repeating-linear-gradient(45deg, #0A1628 0 1px, transparent 1px 14px)",
          }}
        />
        <div className="relative flex flex-col items-start gap-8 px-8 py-14 md:flex-row md:items-center md:justify-between md:px-16 md:py-20">
          <div>
            <MaskedLines
              lines={title.map((t) => (
                <span key={t} className="block font-serif text-4xl font-semibold leading-[1.05] text-navy md:text-6xl">
                  {t}
                </span>
              ))}
              className="block"
            />
            <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-navy/75">{sub}</p>
          </div>
          <Link
            to="/contact"
            data-testid="cta-banner-button"
            className="btn-navy group shrink-0"
          >
            {cta}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </Reveal>
  </section>
);

export default CTABanner;
